import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const PopoverWrapper = styled.div`
  position: relative;
  cursor: pointer;

  .popover-handler {
    display: inline-block;
    cursor: pointer;
  }
`;
export const PopOver = styled.div`
	top: calc(100% + 15px);
	right: 30px;
	display: block;
	min-width: 400px;
	position: absolute;
	border-radius: 5px;
	background-color: #ffffff;
	box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
	z-index: 99;
	// &:before {
	//   content: "";
	//   position: absolute;
	//   width: 0;
	//   height: 0;
	//   border-style: solid;
	//   border-width: 0 8px 9px 8px;
	//   border-color: transparent transparent #ffffff transparent;
	//   top: -8px;
	//   box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
	//   pointer-events: none;
	// }

	@media screen and (max-width: 991px) {
		right: -36px;
		&.right-n {
			right: 11px;
		}
	}
	@media screen and (max-width: 500px) {
		right: -36px;
		min-width: 90vw;
		&.right-n {
			right: 11px;
		}
	}
`;

export const NotificationContainer = styled.div`
	// margin-right: 15px;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	@media screen and (max-width: 991px) {
		margin-left: 15px;
		margin-right: 5px;
		&.right-0 {
			margin-right: 10px;
		}
	}
`;

export const NotificationBadgeContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	width: 23px;
	height: 23px;
	border: 2px solid #fff;
	background-color: #9cc54b;
	font-size: 11px;
	color: rgb(255, 255, 255);
	position: absolute;
	z-index: 1;
	margin-bottom: 25px;
	margin-left: 20px;

	&.express {
		background-color: ${themeGet("colors.expressColor")};
		border: 3px solid #fff;
		width: 23px;
		height: 23px;
	}
`;
export const PopOverHeader = styled.div`
	border-bottom: 1px solid #dfbebe12;
	background-color: #ededed;
	padding: 15px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	.title {
		font-weight: 600;
	}
	.markAsRead {
		font-size: 12px;
		font-weight: 600;
    color: #007bff;
    text-decoration: underline;

		&.disabled {
			color: #6c757d;
			text-decoration: none;
		}
	}
`;
export const PopOverContent = styled.div`
	// max-height: ;
	height: 70vh;
	overflow-y: auto;

  &.express {
    .notification-item {
      &:hover {
        background: #f0126614;
      }

      .mark {
        background: #f01266;
      }
    }
  }

  scrollbar-width: thin;
  scrollbar-color: #d3d3d3 #f5f5f5;

	&::-webkit-scrollbar {
    width: 6px;
  }
	&::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 0 0 6px 0;
  }
	&::-webkit-scrollbar-thumb {
		border-radius: 6px;
    background: #d3d3d3;
	}
`;
export const PopOverFooter = styled.div``;

export const NotificationItem = styled.a`
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px;
	color: #000;
	width: 100%;
	height: max-height;
	border-bottom: 1px solid #ededed;
	&:hover {
		color: #000;
		text-decoration: none;
		background-color: #9cc54b14;
	}
`;
export const NotificationItemIcon = styled.div`
	div {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		border: 1px solid #ededed;
		padding: 10px;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			aspect-ratio: 1/1;
		}
	}
`;
export const NotificationItemContent = styled.div`
	padding: 0 10px;
	width: 100%;
	div.title {
		font-size: 14px;
		color: #000;
		font-weight: 600;
	}
	p {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 14px;
		line-height: 1.2;
	}
	p.time {
		font-size: 12px;
		margin-top: 5px;
		color: #77798c;
	}
`;
export const NotificationItemMark = styled.div`
	div.mark {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: #9cc54b;
		margin-right: 5px;
	}
	div.unmark {
		width: 5px;
		height: 5px;
		margin-right: 5px;
	}
`;

export const LoaderWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: 30px;
`;

export const AbandonedBasketLink = styled.span`
	display: "inline-block";
	marginTop: "1rem";
	color: "#9cc54b";
	cursor: 'pointer';
	&:hover{
		text-decoration: underline;
	}
`;
